const hasOpted = (filer, productsState) => {
    if(!productsState) {
        return null;
    }
	const optedValue = filer === 'primary'
		? productsState.hasPrimaryOptedIn
		: productsState.hasSpouseOptedIn;

	var evaluation = optedValue?.toLowerCase();
    if(evaluation  === 'true') {
        return 'Y';
    }
    else if(evaluation === 'false') {
        return 'N';
    }
    return null;
};
export { hasOpted };